function urlGen (url, port) {
  if (port) return `${url}:${port}`
  return url
}

const proto = process.env.REACT_APP_PROTOCOL
// let alternativePort = window.location.port ? ( ":" + window.location.port ) : ""
let alternativePort = window.location.port || ""
let [ apiUrl, apiUrlPort ] = process.env.REACT_APP_API_URL.split(':');
let [ authUrl_, authUrlPort ] = process.env.REACT_APP_AUTH_URL.split(':');

const url = urlGen(apiUrl, apiUrlPort || alternativePort);
const authUrl = urlGen(authUrl_, authUrlPort || alternativePort );
// const authUrl = process.env.REACT_APP_AUTH_URL + port

let port = alternativePort

export {
  proto,
  port,
  url,
  authUrl,
}
